export class BatchIngestionPipelineMetricsRangeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rangeByPipelineId",
            "baseName": "rangeByPipelineId",
            "type": "{ [key: string]: IngestionPipelineMetricsRange; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchIngestionPipelineMetricsRangeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
